<div>
  @switch (getInputType()) {
    @case (adressInputType.Input) {
      <div>
        <nx-formfield [label]="texte.label">
          <input
            #adressInput="ngModel"
            (ngModelChange)="auswahlChanged.emit($event)"
            [attr.data-cy]="name + '-adress-input'"
            [name]="name + '-adress-input'"
            [attr.aria-label]="texte.ariaLabel ? texte.ariaLabel : texte.label"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [ngModel]="aktuelleAuswahl"
            [nxAriaLabel]="texte.ariaLabel ? texte.ariaLabel : texte.label"
            [disabled]="disabled"
            autocomplete="off"
            nxInput
            pattern="{{ 'ADDRESSE_ORT' | regexpAsString }}"
            required />
          @if (adressInput?.errors) {
            <nx-error
              appearance="text"
              class="nx-margin-bottom-0 nx-margin-top-3xs"
              nxFormfieldError>
              @if (adressInput?.errors?.required) {
                <span
                  [attr.data-cy]="name + '-adress-input-required-error'"
                  [innerHTML]="texte.required"></span>
              }
              @if (adressInput?.errors?.pattern) {
                <span
                  [attr.data-cy]="name + '-adress-input-pattern-error'"
                  [innerHTML]="texte.pattern"></span>
              }
            </nx-error>
          }
        </nx-formfield>
      </div>
    }
    @case (adressInputType.InputReadOnly) {
      <div>
        <nx-formfield [label]="texte.label">
          <input
            (ngModelChange)="auswahlChanged.emit($event)"
            [attr.data-cy]="name + '-adress-input-disabled'"
            [readonly]="true"
            [name]="name + '-adress-input-disabled'"
            [attr.aria-label]="texte.ariaLabel ? texte.ariaLabel : texte.label"
            [ngModel]="aktuelleAuswahl"
            [nxAriaLabel]="texte.ariaLabel ? texte.ariaLabel : texte.label"
            [disabled]="disabled"
            autocomplete="off"
            class="cursor-not-allowed"
            nxInput
            pattern="{{ 'ADDRESSE_ORT' | regexpAsString }}"
            required />
        </nx-formfield>
      </div>
    }
    @case (adressInputType.Dropdown) {
      <div>
        <nx-formfield [label]="texte.label">
          <nx-dropdown
            #adressInputAuswahl="ngModel"
            (ngModelChange)="auswahlChanged.emit($event)"
            [attr.data-cy]="name + '-adress-input-dropdown'"
            [filterFn]="searchFromBeginning"
            [name]="name + '-adress-input-dropdown'"
            [ngModel]="aktuelleAuswahl"
            [filterPlaceholder]="texte.dropdownPlaceholder"
            [disabled]="disabled"
            [showFilter]="true"
            required>
            @for (auswahlElement of auswahlListe; track auswahlElement) {
              <nx-dropdown-item [value]="auswahlElement"> </nx-dropdown-item>
            }
          </nx-dropdown>
          <nx-error
            appearance="text"
            class="nx-margin-bottom-0 nx-margin-top-0"
            nxFormfieldError>
            @if (adressInputAuswahl?.errors?.required) {
              <span
                [attr.data-cy]="name + '-adress-input-dropdown-required-error'"
                [innerHTML]="texte.required"
                nxError></span>
            }
          </nx-error>
        </nx-formfield>
      </div>
    }
  }
</div>
